export default {

    loadLearningTopics(courseId) {
        let stored = window.localStorage.getItem('learning_topics_' + courseId);
        return stored ? JSON.parse(stored) : null;
    },

    saveLearningTopics(courseId, topics) {
        window.localStorage.setItem('learning_topics_' + courseId, JSON.stringify(topics));
    },

    clearLearningTopics(courseId) {
        window.localStorage.removeItem('learning_topics_' + courseId);
    },

    getLatestLearningQuestion(courseId) {
        let stored = window.localStorage.getItem('learning_question_' + courseId);
        return stored ? parseInt(stored, 10) : 1;
    },

    setLearningRandomQuestion(randomQuestion) {
        window.localStorage.setItem('learning_random_question', randomQuestion ? 1 : 0);
    },

    getLearningRandomQuestion() {
        let stored = window.localStorage.getItem('learning_random_question');
        return stored === '1';
    },

    setLearningRandomAnswers(randomAnswers) {
        window.localStorage.setItem('learning_random_answers', randomAnswers ? 1 : 0);
    },

    getLearningRandomAnswers() {
        let stored = window.localStorage.getItem('learning_random_answers');
        return stored === '1';
    },

    setLatestLearningQuestion(courseId, questionNumber) {
        window.localStorage.setItem('learning_question_' + courseId, questionNumber);
    },

    saveExam(courseId, data) {
        window.localStorage.setItem('exam_' + courseId, data);
    },

    loadExam(courseId) {
        let stored = window.localStorage.getItem('exam_' + courseId);

        if (stored) {
            return JSON.parse(stored);
        }

        return null;
    },

}